<div class="app-page-title">
  <div class="page-title-wrapper">
    <div class="page-title-heading">
      <div class="page-title-icon">
        <i class="pe-7s-plane icon-gradient bg-mean-fruit"> </i>
      </div>
      <div>
        {{ "data.trailer" | translate }}
        <div class="page-title-subheading">
          {{ "data.trialer_list" | translate }}.
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isLoading; else elseAllTrailers">
  <div class="row">
    <div class="col-md-12">
      <div class="main-card mb-3 card">
        <div class="card-body text-center">
          <div class="spinner-container blue-spinner">
            <mat-progress-spinner
              mode="indeterminate"
              [diameter]="40"
              [strokeWidth]="5"
            ></mat-progress-spinner>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #elseAllTrailers>
  <div class="row">
    <div class="col-md-12">
      <div class="main-card mb-3 card">
        <div class="card-header">{{ "data.trailers" | translate }}</div>
        <div class="table-responsive">
          <div
            class="budget-price justify-content-center"
            *ngIf="trailerList?.length === 0"
          >
            <h2 class="text-center text-danger">
              {{ "data.no_trailer_created" | translate }}
            </h2>
          </div>
          <table
            class="align-middle mb-0 table table-borderless table-striped table-hover"
            *ngIf="trailerList?.length > 0"
          >
            <thead>
              <tr>
                <th class="text-center">#</th>
                <th>{{ "data.trailer_number" | translate }}</th>
                <th>{{ "data.creation_date" | translate }}</th>

                <th>{{ "data.Transport_type" | translate }}</th>
                <th>{{ "data.plateform" | translate }}</th>

                <th class="text-center">
                  {{ "data.volume" | translate }} <br />
                  {{ "data.pallet" | translate }}<br />(m³)
                </th>
                <th class="text-center">
                  {{ "data.total_weight" | translate }} <br />
                  (Kg)
                </th>
                <th class="text-center">Total (€)</th>

                <th class="text-center" data-width="100">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of trailerList; let index = index">
                <td class="text-center text-muted">#{{ index + 1 }}</td>
                <td>
                  <b>{{ item.remorqueId }}</b>
                </td>
                <td class="text-left">
                  {{ item.creation_date | date : "d MMM y" }}<br />
                  <b>{{ item.creation_date | date : "HH:mm" }}</b>
                </td>

                <td class="text-left">
                  {{ item.transportorType }}
                </td>
                <td class="text-left">
                  {{ item.plateform }}
                </td>

                <td class="text-center">
                  {{ item?.totalVolume | number : "0.1" }}
                </td>
                <td class="text-center">
                  {{ item?.totalWeight | number : "0.1" }}
                </td>
                <td class="text-center">
                  {{ item?.totalCost | number : "0.1" }}
                </td>

                <td class="text-center">
                  <div
                    class="mb-2 mr-2 dropright btn-group"
                    ngbDropdown
                    placement="left-top"
                  >
                    <button class="btn-wide btn btn-info">Actions</button>
                    <button
                      type="button"
                      ngbDropdownToggle
                      class="dropdown-toggle-split btn btn-info"
                    >
                      <span class="sr-only">Actions</span>
                    </button>
                    <div ngbDropdownMenu>
                      <button
                        type="button"
                        [routerLink]="['/detail-trailer']"
                        [queryParams]="{ trailerId: item?._id }"
                        tabindex="0"
                        class="dropdown-item"
                      >
                        <i
                          class="metismenu-icon pe-7s-check text-warning"
                          style="margin-right: 10px"
                        ></i
                        >{{ "data.generate_purchase_order" | translate }}
                      </button>
                      <button
                        type="button"
                        (click)="deleteTrailer(item?._id)"
                        tabindex="0"
                        class="dropdown-item"
                      >
                        <i
                          class="metismenu-icon pe-7s-trash text-danger"
                          style="margin-right: 10px"
                        ></i
                        >{{ "data.delete_trailer" | translate }}
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="d-block text-center card-footer"
          *ngIf="trailerList?.length > 0 && pages?.length > 1"
        >
          <nav aria-label="Page navigation example">
            <ul class="pagination justify-content-center">
              <li
                [ngClass]="
                  currentPage === 0 ? 'page-item disabled' : 'page-item'
                "
              >
                <a class="page-link" tabindex="-1" (click)="previousPage()">
                  <i class="nav-link-icon pe-7s-angle-left-circle"></i>
                  {{ "data.previous" | translate }}</a
                >
              </li>

              <div *ngFor="let p of pagesDisplaied">
                <li
                  [ngClass]="
                    currentPage === p ? 'page-item active' : 'page-item'
                  "
                >
                  <a
                    *ngIf="currentPage !== p"
                    class="page-link"
                    (click)="selectPage(p)"
                    >{{ p + 1 }}</a
                  >

                  <span *ngIf="currentPage === p" class="page-link">
                    {{ p + 1 }}
                    <span class="sr-only">(current)</span>
                  </span>
                </li>
              </div>

              <li
                [ngClass]="
                  currentPage === totalPages - 1
                    ? 'page-item disabled'
                    : 'page-item'
                "
              >
                <a class="page-link" tabindex="-1" (click)="nextPage()"
                  >{{ "data.next" | translate }}
                  <i class="nav-link-icon pe-7s-angle-right-circle"></i
                ></a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</ng-template>
